import React, { useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import axios from 'axios';
import { useEffect } from 'react';
import ToastNotification from '../../../components/ToastNotification';
import ConfirmDialog from '../../../components/ConfirmDialog';

import { useLoading } from '../../../context/LoadingContext';


const LeaveMaster = () => {
    const { setLoading } = useLoading();
    //===================== useStates==================
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });
    const [confirmDialog, setConfirmDialog] = useState({
        show: false,
        id: null,
        message: '',
    });

    const [searchTerm, setSearchTerm] = useState('');

    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);


    const [showForm, setShowForm] = useState(false);

    const [finalData, setFinalData] = useState([]);

    const [formData, setFormData] = useState({
        leave_name: '',
        entitlement: '',
        short_name: '',
        min_days: '',
        max_days: '',
        encashable: false,
        excludeHolidays: false,
        clubbingAllowed: false,
        carryForward: false,
        excludeWeeklyOff: false
    });
    // console.log(formData);


    // =================api============================
    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };


    const fetchLeaveMaster = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-leave-master');
            // console.log(res.data.result)

            setFinalData(res.data.result);
        } catch (error) {
            console.error("Error fetching Leave Master:", error);
            // alert("Failed to fetch Leave Master data. Please try again later.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchLeaveMaster();
    }, [])

    //===================== handlers==================
    const handleFormOpen = () => {
        setShowForm(true);
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                ...formData,
                min_days: formData.min_days === '' ? null : formData.min_days,
                max_days: formData.max_days === '' ? null : formData.max_days,
                encashable: Boolean(formData.encashable),
                excludeHolidays: Boolean(formData.excludeHolidays),
                clubbingAllowed: Boolean(formData.clubbingAllowed),
                carryForward: Boolean(formData.carryForward),
                excludeWeeklyOff: Boolean(formData.excludeWeeklyOff)
            };

            if (isEditing) {
                const res = await axios.put(`https://api.skyguard.group/api/update-leave-master/${editingId}`, payload);

                showToast('Leave Master updated successfully!', 'success');
                console.log("Server response", res.data.message);
                setFinalData(prev =>
                    prev.map(item => item.id === editingId ? { id: editingId, ...formData } : item)
                );
            } else {
                const res = await axios.post('https://api.skyguard.group/api/add-leave-master', payload);

                showToast('Leave Master added successfully!', 'success');
                console.log("Server reponse", res.data.message);

                setFinalData(prev => [
                    ...prev,
                    { id: res.data.insertId, ...formData }
                ]);
            }
            fetchLeaveMaster();
            setFormData({
                leave_name: '',
                entitlement: '',
                short_name: '',
                min_days: '',
                max_days: '',
                encashable: false,
                excludeHolidays: false,
                clubbingAllowed: false,
                carryForward: false,
                excludeWeeklyOff: false
            });
            setIsEditing(false);
            setEditingId(null);
            setShowForm(false);

        } catch (error) {
            console.error(' Error adding Leave Master:', error);
            showToast('Error adding Leave Master.', 'danger');
        }

        // if (isEditing) {
        //     const updatedData = [...finalData];
        //     updatedData[editingId] = formData;
        //     setFinalData(updatedData);
        //     setIsEditing(false);
        //     setEditingId(null);
        // } 
    }

    // const handleDelete = async (id) => {

    //     if (!window.confirm("Are you sure to delete this Leave Master ?")) return;

    //     try {
    //         const res = await axios.delete(`https://api.skyguard.group/api/delete-leave-master/${id}`);
    //         // alert(res.data.message);
    //         // console.log(res.data);
    //         fetchLeaveMaster();

    //         setFinalData(prev => prev.filter(item => item.id !== id));
    //         showToast('Leave Master deleted successfully!', 'success');

    //         if (isEditing && editingId === id) {
    //             setIsEditing(false);
    //             setEditingId(null);
    //             setShowForm(false);
    //             setFormData({
    //                 leave_name: '',
    //                 entitlement: '',
    //                 short_name: '',
    //                 min_days: '',
    //                 max_days: '',
    //                 encashable: false,
    //                 excludeHolidays: false,
    //                 clubbingAllowed: false,
    //                 carryForward: false,
    //                 excludeWeeklyOff: false
    //             });
    //         }
    //     } catch (error) {
    //         console.error("Error deleting Leave Master:", error);
    //         showToast('Error deleting Leave Master', 'danger');
    //     }
    // };

    // filter
    const handleDeleteClick = (id) => {
        setConfirmDialog({
            show: true,
            id,
            message: "Are you sure you want to delete this Leave Master?",
        });
    };

    const handleConfirmDelete = async () => {
        try {
            const res = await axios.delete(`https://api.skyguard.group/api/delete-leave-master/${confirmDialog.id}`);
            showToast('Leave Master deleted successfully!', 'success');

            setFinalData(prev => prev.filter(item => item.id !== confirmDialog.id));

            if (isEditing && editingId === confirmDialog.id) {
                setIsEditing(false);
                setEditingId(null);
                setShowForm(false);
                setFormData({
                    leave_name: '',
                    entitlement: '',
                    short_name: '',
                    min_days: '',
                    max_days: '',
                    encashable: false,
                    excludeHolidays: false,
                    clubbingAllowed: false,
                    carryForward: false,
                    excludeWeeklyOff: false
                });
            }
        } catch (error) {
            console.error("Error deleting Leave Master:", error);
            showToast('Error deleting Leave Master', 'danger');
        } finally {
            setConfirmDialog({ show: false, id: null, message: '' });
        }
    };



    const filteredData = finalData.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );




    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Leave Master</h3>

                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleFormOpen}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button>
                        </div>
                    </div>
                    {/* show-Form */}
                    {showForm && (
                        <div className='card p-3 my-3 shadow-sm bg-white border'>
                            <form onSubmit={handleSubmit}>
                                <div className='row'>

                                                          {isEditing && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {formData.leave_name}
    </span>
  </div>
)}
                                    {/* left side */}
                                    <div className='col-md-6'>
                                        <div className='row g-3'>
                                            {/* Leave Name */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Leave Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="leave_name"
                                                    placeholder="Enter Name..."
                                                    value={formData.leave_name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            {/* Entitlement */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Entitlement</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="entitlement"
                                                    placeholder="Enter Entitlement..."
                                                    value={formData.entitlement}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            {/* ShortName */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">ShortName</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="short_name"
                                                    placeholder="Enter ShortName..."
                                                    value={formData.short_name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* right-side */}
                                    <div className='col-md-6'>
                                        <div className='row g-3'>
                                            {/* min-max days */}
                                            <div className="col-12">
                                                <div className='row g-2'>
                                                    <div className='col-md-6'>
                                                        <label className="form-label fw-medium">Min Days</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="min_days"
                                                            placeholder="Enter..."
                                                            value={formData.min_days}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label className="form-label fw-medium">Max Days</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="max_days"
                                                            placeholder="Enter..."
                                                            value={formData.max_days}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Options */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Options</label>
                                                <div className='card p-3 border'>
                                                    <div className="form-check mt-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="encashable"
                                                            checked={formData.encashable}
                                                            onChange={handleChange}
                                                        />
                                                        <label className="form-check-label">Encashable</label>
                                                    </div>
                                                    <div className="form-check mt-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="excludeHolidays"
                                                            checked={formData.excludeHolidays}
                                                            onChange={handleChange}
                                                        />
                                                        <label className="form-check-label">ExcludeHolidays</label>
                                                    </div>
                                                    <div className="form-check mt-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="clubbingAllowed"
                                                            checked={formData.clubbingAllowed}
                                                            onChange={handleChange}
                                                        />
                                                        <label className="form-check-label">ClubbingAllowed</label>
                                                    </div>
                                                    <div className="form-check mt-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="carryForward"
                                                            checked={formData.carryForward}
                                                            onChange={handleChange}
                                                        />
                                                        <label className="form-check-label">CarryForward</label>
                                                    </div>
                                                    <div className="form-check mt-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="excludeWeeklyOff"
                                                            checked={formData.excludeWeeklyOff}
                                                            onChange={handleChange}
                                                        />
                                                        <label className="form-check-label">ExcludeWeeklyOff</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/* save/Cancel */}
                                <div className='d-flex justify-content-center mt-4 gap-2'>
                                    <button type='submit' className='btn btn-success'>
                                        {isEditing ? 'UPDATE' : 'SAVE'}
                                    </button>
                                    <button type='button' className='btn btn-danger' onClick={() => {
                                        setShowForm(false);
                                        setIsEditing(false);
                                        setEditingId(null);
                                        setFormData({
                                            leave_name: '',
                                            entitlement: '',
                                            short_name: '',
                                            min_days: '',
                                            max_days: '',
                                            encashable: false,
                                            excludeHolidays: false,
                                            clubbingAllowed: false,
                                            carryForward: false,
                                            excludeWeeklyOff: false
                                        });
                                    }}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                    {/*  Main- table */}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>SL</th>
                                       <th>Action</th>
                                    <th>Name</th>
                                    <th>Min</th>
                                    <th>Max</th>
                                    <th>Entitlement</th>
                                    <th>ClubbingAllowed</th>
                                    <th>CarryForward</th>
                                    <th>Encashable</th>
                                    <th>ExcludeWeeklyOff</th>
                                    <th>ShortName</th>
                                 
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((data, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                              <td>
                                                <button className='btn btn-sm btn-primary mx-1'
                                                    onClick={() => {
                                                        setFormData({
                                                            ...data,
                                                            min_days: data.min_days ?? '',
                                                            max_days: data.max_days ?? ''
                                                        });
                                                        setIsEditing(true);
                                                        setEditingId(data.id);
                                                        setShowForm(true);
                                                    }}
                                                >
                                                    <AiOutlineEdit size={18} /></button>
                                                <button className='btn btn-sm btn-danger mx-1'><AiOutlineDelete size={18} onClick={() => handleDeleteClick(data.id)} /></button>
                                            </td>
                                            <td>{data.leave_name}</td>
                                            <td>{data.min_days}</td>
                                            <td>{data.max_days}</td>
                                            <td>{data.entitlement}</td>
                                            <td>{data.clubbingAllowed ? <AiOutlineCheck color="green" size={18} /> : <AiOutlineClose color="red" size={20} />}</td>
                                            <td>{data.carryForward ? <AiOutlineCheck color="green" size={18} /> : <AiOutlineClose color="red" size={20} />}</td>
                                            <td>{data.encashable ? <AiOutlineCheck color="green" size={18} /> : <AiOutlineClose color="red" size={20} />}</td>
                                            <td>{data.excludeWeeklyOff ? <AiOutlineCheck color="green" size={18} /> : <AiOutlineClose color="red" size={20} />}</td>
                                            <td>{data.short_name}</td>
                                          
                                        </tr>
                                    ))) : (
                                    <tr>
                                        <td colSpan="11" className="text-center text-danger fw-bold text-muted">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast(prev => ({ ...prev, show: false }))}
                />

            <ConfirmDialog
                show={confirmDialog.show}
                title="Delete Leave Master"
                message={confirmDialog.message}
                onConfirm={handleConfirmDelete}
                onCancel={() => setConfirmDialog({ show: false, id: null, message: '' })}
            />


        </>
    )
}

export default LeaveMaster
